import { render, staticRenderFns } from "./ChatboxModalConfirmOrderReply.vue?vue&type=template&id=3faf0449&scoped=true&"
import script from "./ChatboxModalConfirmOrderReply.vue?vue&type=script&lang=js&"
export * from "./ChatboxModalConfirmOrderReply.vue?vue&type=script&lang=js&"
import style0 from "./ChatboxModalConfirmOrderReply.vue?vue&type=style&index=0&id=3faf0449&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf0449",
  null
  
)

export default component.exports